/* eslint-disable max-lines */
import otherUtils from '@mdm/utils/otherCommonFunc';
import btnAuthority from '@mdm/btnAuthority';
import { biddingAccountImportApi, biddingAccountDownloadApi } from '@/modules/mdm/api/customer/biddingAccountManage.js';
import { urlRegNoRequireHttps, phoneReg } from '@/modules/mdm/utils/regList.js';
export const config = {
    name: 'biddingAccountManage',
    searchFields: [
        {
            name: '客户名称',
            value: 'customerName',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '客户系名称',
            value: 'customerGroupName',
            isFixed: true,
            type: 'input',
            span: 3
        },
        {
            name: '投标网站名称',
            value: 'websiteName',
            isFixed: true,
            type: 'input',
            span: 3
        },
        {
            name: '账号所有人',
            value: 'accountManager',
            isFixed: true,
            type: 'input',
            span: 3
        },
        {
            name: '账号绑定人',
            value: 'accountRegistrant',
            isFixed: true,
            type: 'input',
            span: 3
        },
        {
            name: '账号状态',
            value: 'accountStatus',
            optionNum: 'CUSTOMER_TENDERER_ACCOUNT_STATUS',
            isFixed: true,
            type: 'select',
            span: 3
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '客户名称',
            prop: 'customerName',
            mustFill: true,
            type: 'advance',
            name: '请输入客户名称或编码查询',
            value: 'customerName',
            width: 180,
            // advanceConfig配置搜索条件，tableConfig配置弹窗中的表格列信息
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerGroupName', value: '客户系名称' },
                { prop: 'customerOwnerName', value: '客户经理' },
                { prop: 'calCustomerLevelCode', value: '细分等级', type: 'select', optionsKey: 'NEOCRM_CUSTOMER_LEVEL' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            method: 'post',
            cbParams: ['customerCode', 'customerName#customerName', 'customerChannel', 'customerGroupCode', 'customerGroupName',
                'customerLevelCode#customerLevel', 'customerOwnerName', 'customerOwnerCode'],
            // eslint-disable-next-line complexity
            beforeRequest: (params) => {
                params.customerStatus = '1';
                const inputKey = (params.customerName ? params.customerName : (params.customerCode ? params.customerCode : '')).trim();
                // 检查inputKey是否符合使用name的条件
                const hasChinese = /[\u4e00-\u9fa5]/.test(inputKey);
                const englishCount = (inputKey.match(/[a-zA-Z]/g) || []).length;
                const hasSymbol = /[^\w\s]/.test(inputKey);
                // 规则: 如果inputKey包含中文、英文长度大于1、或存在符号，则使用name
                if (hasChinese || englishCount > 1 || hasSymbol) {
                    params.customerName = inputKey;
                    params.customerCode = null;
                } else {
                    params.customerName = null;
                    params.customerCode = inputKey;
                }
                return params;
            }
            // filterType: 'input',
            // filterMultiple: false
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            width: 150
        },
        {
            label: '客户等级',
            prop: 'customerLevel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 100,
            filterType: 'select',
            filterMultiple: false
        },
        {
            label: '客户经理/开发人',
            prop: 'customerOwnerName',
            width: 150
        },
        {
            label: '投标网站名称',
            prop: 'websiteName',
            width: 140,
            type: 'input',
            maxlength: 200,
            mustFill: true
        },
        {
            label: '投标网址',
            prop: 'websiteUrl',
            width: 180,
            type: 'input',
            verify: urlRegNoRequireHttps,
            mustFill: true,
            slot: true
        },
        {
            label: '投标账号类型',
            prop: 'accountType',
            type: 'slot',
            slot: true,
            editSlot: true,
            disabled: true,
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_TYPE',
            width: 110
        },
        {
            label: '账号',
            prop: 'websiteAccount',
            width: 130,
            maxlength: 50,
            type: 'input',
            mustFill: true,
            slot: true
        },
        {
            label: '密码',
            prop: 'accountPassword',
            width: 120,
            type: 'input',
            maxlength: 50,
            mustFill: true,
            slot: true
        },
        {
            label: '账号状态',
            prop: 'accountStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            disabled: true,
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_STATUS',
            width: 90
        },
        {
            label: '绑定手机号',
            prop: 'registrantPhone',
            width: 150,
            type: 'input',
            mustFill: true,
            verify: phoneReg,
            slot: true
        },
        {
            label: '账号绑定人',
            prop: 'accountRegistrant',
            width: 150,
            type: 'input'
        },
        {
            label: '账号绑定人名称',
            prop: 'accountRegistrantName',
            width: 120,
            slot: true,
            disabled: true
        },
        {
            label: '账号所有人',
            name: '账号所有人',
            prop: 'accountManager',
            type: 'advance',
            mustFill: true,
            width: 160,
            // maxNum: 10, // 多选条数限制
            isFixed: false,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                // { 'prop': 'esusPositionName', 'value': '职位' }, // 新接口没有这个字段
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/crmUser/page`,
            cbParams: ['esusLoginName#accountManager', 'esusUserNameCn#accountManagerName'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            label: '账号所有人名称',
            prop: 'accountManagerName',
            width: 120
        },
        {
            label: '账号所有人状态',
            prop: 'accountManagerStatus',
            optionsKey: 'CRM_USER_INFO_STATUS',
            // type: 'slot',
            // slot: true,
            // editSlot: true,
            width: 120,
            filterType: 'select',
            filterMultiple: false
        },
        {
            label: '90天内是否有更新',
            prop: 'hasUpdateIn90days',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'YES_OR_NO',
            disabled: true,
            width: 140,
            filterType: 'select',
            filterMultiple: false
        },
        {
            label: '备注',
            prop: 'remark',
            width: 180,
            type: 'slot',
            maxlength: 500,
            editSlot: true
        },
        {
            label: '是否已复核',
            prop: 'isReviewed',
            type: 'select',
            optionsKey: 'YES_OR_NO',
            width: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 150,
            filterType: 'dateRange',
            filterDateFormat: 'yyyy-MM-dd HH:mm:ss',
            filterValueFormat: 'yyyy-MM-dd HH:mm:ss',
            startPlaceholder: '创建时间从',
            endPlaceholder: '创建时间到',
            popoverWidth: 280
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: 150,
            filterType: 'dateRange',
            filterDateFormat: 'yyyy-MM-dd HH:mm:ss',
            filterValueFormat: 'yyyy-MM-dd HH:mm:ss',
            startPlaceholder: '更新时间从',
            endPlaceholder: '更新时间到',
            popoverWidth: 280
        },
        {
            label: '账号所有人更新时间',
            prop: 'managerUpdateTime',
            width: 170
        },
        {
            label: '密码更新时间',
            prop: 'passwordUpdateTime',
            width: 160
        }
    ],
    matchOperator: {
        customerLevel: 'IN',
        managerStatus: 'IN',
        hasUpdateIn90days: 'IN',
        createTime: 'CONTAINS',
        updateTime: 'CONTAINS'
    },
    actions: {
        fixedWidth: 150,
        list: [
            {
                label: '废弃',
                event: 'discard',
                displayRule: (row) => {
                    const hasAuth = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.discard);
                    const isCreator = row.createUserCode === row.accountRegistrant;
                    const isActive = row.accountStatus === 'active';
                    return hasAuth && isCreator && isActive;
                }
            },
            {
                label: '重启',
                event: 'enable',
                displayRule: (row) => {
                    const hasAuth = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.enable);
                    const isCreator = row.createUserCode === row.accountRegistrant;
                    const isNotActive = row.accountStatus !== 'active';
                    return hasAuth && isCreator && isNotActive;
                }
            }
        ]
    },
    importConfig: {
        downBtn: true,
        action: '',
        multiple: false,
        accept: 'xlsx',
        showFileList: false,
        fileType: '只能上传Excel文件',
        manualUpload: true,
        fileName: '投标账号导入模板.xlsx',
        beforeRequest: () => {

        },
        downloadApi: biddingAccountDownloadApi,
        importApi: biddingAccountImportApi
    }
};
